<template>
    <div class="order-groups">
        <div class="order-header">
            <span v-if="editabled">
                <Checkbox style="margin-left: 8px;" v-on:on-change="selectAll">Selected All</Checkbox>
            </span>
            <span v-if="editabled ===false">&nbsp;</span>
            <span>Category</span>
            <span>Unit Price</span>
            <span>Quantity</span>
            <span>Selected all</span>
            <span>Operation</span>
        </div>
        <slot>
            <order-list></order-list>
        </slot>
    </div>
</template>
<script>
    import orderList from './OrderList.vue'

    export default {
        data () {
            return {}
        },
        components: {
            'order-list': orderList
        },
        methods: {
            selectAll (index) {
                this.$emit('select-all', index)
            }
        },
        props: {
            editabled: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
<style lang="scss">
    .order-groups {
        .order-header {
            display: flex;
            flex-wrap: nowrap;
            margin: 10px 0;
            span {
                flex: 1;
                font-size: 14px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 20px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// OrderGroup.vue?f1d7a818